export const toTree = (array, rootId) => {
    const rootItems = array.filter(e => (e.parentId ?? 0) === (rootId ?? 0))
    for (const item of rootItems) {
        item.children = toTree(array, item.id)
    }
    return rootItems
}
